import React from 'react';
import {uploadPrices} from '../epics-pharmacies';
import {Link} from 'react-router-dom';

import {CancelBtn, MainBtn} from '../../Common/form/Elements-export';

import localStorage from '../../Common/LocalStorage';
import LocalizedStrings from 'react-localization';
import {translations} from '../../Common/Translations';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang'));

class UploadPharmacyPricesModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pharmacy_id: props.pharmacyId,
            prices_url: props.pricesURL, // ? props.pricesURL : '#',
            has_new_prices: false,
            pricingMode: props.pricingMode,
            pricingOverwrite: false,
            pricing_file: null,
            loadingSpinner: false,
            validation_msg: null
        };
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount = () => {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(e) {
        if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
            //this.setState({ ...this.state, pharmacy_id: 0, prices_url: '#' });
        }
    }

    handlePricesChange = changeEvent => {
        var file = changeEvent.target.files[0];
        var self = this;

        if (file) {

            if (file.type === '' ||
                file.type === 'text/csv' ||
                file.type === 'application/ms-tnef' ||
                file.type === 'application/vnd.ms-excel' ||
                file.type === 'application/octet-stream'
            ) {
                self.state.pricing_file = changeEvent.target.files[0];
                self.setState({...this.state, validation_msg: null});
                self.setState({
                    ...self.state,
                    has_new_prices: true
                });
            } else {
                self.setState({...this.state, has_new_prices: false});
                self.setState({...this.state, validation_msg: 'Wrong file type! Use .csv or .dat. You tried to upload '+ file.type});
            }

        }

    };

    update = type => e => {
        this.setState({...this.state, [type]: e.target.value});
    };

    updateOverwrite = type => e => {
        this.setState({ ...this.state, [type]: e.target.checked });
    };

    alerter = type => e => {
        this.setState({ pricingMode: Number(e.target.value), has_new_prices: true});
    };

    generatePricingOptions = pricingModes => {
        var self = this;
        var priceModeOptions = pricingModes.map(
            (onePricingMode, index) =>
                <div key={index} className="align-self-center pr-2 qf-inline-block" style={{display: 'inline-block' }}>
                    <input
                        type="radio"
                        id={"mode_"+onePricingMode}
                        name="pricingMode"
                        value={onePricingMode}
                        checked={self.state.pricingMode === onePricingMode}
                        onChange={self.alerter()}
                    />
                    <label htmlFor={"mode_"+onePricingMode}>
                        {strings.pricingOptions[onePricingMode]}
                    </label>
                </div>
        );

        return priceModeOptions;

    };

    uploadPharmacyPrices = type => {

        var self = this;
        var formData = new FormData();
        formData.append('pharmacy_id', this.state.pharmacy_id);
        formData.append('pricingMode', this.state.pricingMode);
        formData.append('pricingOverwrite', this.state.pricingOverwrite);
        formData.append('csv_file', this.state.pricing_file);
        this.setState({
            ...this.state,
            loadingSpinner: true
        });
        uploadPrices(formData, this.state.pharmacy_id)
            .then(function (response) {
                self.setState({loadingSpinner: false,  has_new_prices: false});
                if(response.body.pricesUrl){
                    self.setState({prices_url: response.body.pricesUrl});
                }
                self.fileInput.value = null;
                self.setState({...self.state});

                alert(strings.prices_saved);
            })
            .catch(function (e) {
                self.setState({...self.state, loadingSpinner: false, has_new_prices: false});
            });
    };

    showWarningBeforeSave = () => {
        this.setState({...this.state, activeWarning: true});
    };

    continueWhitoutSave = () => {
        this.setState({...this.state, activeWarning: false});
    };


    handleCloseModal = () => {
    	this.fileInput.value = null;
        this.setState({...this.state});
        this.props.closeModal();
    };

    generateErrorsMessages = message => (message === '' ? null : <div className="qf-error-message">{message}</div>);

    render() {
        return (
            <div id="upload-pharmacy-prices-wrapper" ref={this.setWrapperRef}>
                <div className="modal-header mb-4">
                    <h5 className="modal-title">
                        {strings.set_pharmacy_prices}
                    </h5>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-7 text-left">
                            <div className="row">
                                <div className="col-12 text-center">
                                    <h3 className="qf-text-label">
                                        {strings.set_pricing_mode}
                                    </h3>
                                </div>
                                <div className="col-12 text-center">
                                    {this.generatePricingOptions([0, 1, 2, 3])}
                                </div>
                            </div>

                        </div>

                        <div className="col-5 text-left">
                            <div className="row">
                                {this.state.prices_url ? (
                                    <div className="col-12">
                                        <h3>Current file: <Link to={"https:"+this.state.prices_url} download="download"
                                                                target="_blank">{strings.download_prices}</Link></h3>
                                    </div>
                                ) : (
                                    <div className="col-12">
                                        <h3>{strings.no_pricing_file}</h3>
                                    </div>
                                )
                                }

                                <div className="col-12">
                                    <input className="qf-file-input" name="csv_file" type="file"
                                           ref={ref=> this.fileInput = ref}
                                           onChange={this.handlePricesChange}/>
                                </div>

                                <div className="col-8 offset-2">
                                    <br/>
                                    <input
                                        className="qf-subscription-btn"
                                        type="checkbox"
                                        onChange={this.updateOverwrite('pricingOverwrite')}
                                        checked={this.state.pricingOverwrite}
                                    />
                                    <span className="qf-subscription-text">{strings.overwrite_prices}</span>
                                </div>

                                <div className="col-12 text-center">
                                    {this.generateErrorsMessages(this.state.validation_msg)}
                                </div>

                            </div>

                        </div>
                        <div className="col-12">
                            <div className="space-top1" style={{paddingTop: 30+'px'}}></div>
                        </div>
                    </div>


                    {this.state.loadingSpinner ? (
                        <div className="row">
                            <div className="col-11 white-bg px-5 text-center p-3">
                                <i className="fa fa-spinner fa-spin fa-2x" style={{ color: '#858585' }}/>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-6 text-right">
                                <MainBtn
                                    onclick={() => this.uploadPharmacyPrices('upload')}
                                    title="Save"
                                    extraClasses="qf-blue-btn w-25"
                                    disabledBtn={!this.state.has_new_prices}
                                />
                            </div>
                            <div className="col-6 text-left">
                                <CancelBtn
                                    title={strings.cancel}
                                    extraClasses="qf-gray-btn w-25"
                                    onclick={this.handleCloseModal}/>
                            </div>
                        </div>
                    )}

                </div>

            </div>
        )
    }
}

export default UploadPharmacyPricesModal;


// WEBPACK FOOTER //
// ./src/customModules/Pharmacies/components/UploadPharmacyPricesModal.js